var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableGreenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_684_27804)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 29,
    height: 29,
    rx: 5,
    fill: "#43AC43"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3589 20.5911C24.0613 19.0745 25 17.3536 25 17.3536C25 17.3536 22 11.8536 17 11.8536C15.9846 11.8536 15.0517 12.0804 14.2097 12.4419L14.9805 13.2128C15.6098 12.9867 16.2844 12.8536 17 12.8536C19.1194 12.8536 20.879 14.0217 22.1679 15.3107C22.8037 15.9465 23.2978 16.5855 23.6327 17.066C23.7055 17.1703 23.7704 17.2668 23.8273 17.3536C23.7704 17.4403 23.7055 17.5368 23.6327 17.6411C23.2978 18.1216 22.8037 18.7606 22.1679 19.3964C22.0031 19.5613 21.8306 19.7241 21.6506 19.8828L22.3589 20.5911Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2975 18.5297C20.4286 18.1621 20.5 17.7662 20.5 17.3536C20.5 15.4206 18.933 13.8536 17 13.8536C16.5874 13.8536 16.1914 13.925 15.8239 14.0561L16.6462 14.8784C16.7618 14.862 16.8799 14.8536 17 14.8536C18.3807 14.8536 19.5 15.9728 19.5 17.3536C19.5 17.4737 19.4915 17.5918 19.4752 17.7074L20.2975 18.5297Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3538 19.8287L18.1762 20.651C17.8086 20.7821 17.4126 20.8536 17 20.8536C15.067 20.8536 13.5 19.2866 13.5 17.3536C13.5 16.9409 13.5714 16.545 13.7025 16.1774L14.5248 16.9997C14.5085 17.1153 14.5 17.2334 14.5 17.3536C14.5 18.7343 15.6193 19.8536 17 19.8536C17.1201 19.8536 17.2383 19.8451 17.3538 19.8287Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3494 14.8243C12.1695 14.983 11.9969 15.1458 11.8321 15.3107C11.1963 15.9465 10.7022 16.5855 10.3673 17.066C10.2945 17.1703 10.2296 17.2668 10.1727 17.3536C10.2296 17.4403 10.2945 17.5368 10.3673 17.6411C10.7022 18.1216 11.1963 18.7606 11.8321 19.3964C13.121 20.6854 14.8806 21.8536 17 21.8536C17.7156 21.8536 18.3902 21.7204 19.0195 21.4943L19.7904 22.2652C18.9483 22.6267 18.0154 22.8536 17 22.8536C12 22.8536 9 17.3536 9 17.3536C9 17.3536 9.93872 15.6326 11.6411 14.116L12.3494 14.8243Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6464 23.7071L10.6464 11.7071L11.3536 11L23.3536 23L22.6464 23.7071Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_684_27804",
    x: 0,
    y: 0,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_684_27804"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_684_27804",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableGreenEye);
export default __webpack_public_path__ + "static/media/table-green-eye.bc490ff506c7c984b2ea267bd822d8ad.svg";
export { ForwardRef as ReactComponent };